exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sortModelInput {\n  width: 20rem;\n  margin-top: 1.8rem; }\n  .sortModelInput .title {\n    text-align: center; }\n  .sortModelInput .list {\n    margin-top: 0.7rem;\n    display: flex;\n    flex-direction: column; }\n    .sortModelInput .list .name {\n      margin-right: auto;\n      cursor: pointer; }\n  .sortModelInput .sort-option {\n    align-items: center;\n    display: flex;\n    margin-top: 0.2rem; }\n    .sortModelInput .sort-option.dragging {\n      opacity: 0.4; }\n", ""]);

// exports
